<template>
  <div id="v-date-time">
    <v-text-field
      ref="editor"
      v-model="displayDate"
      :label="label"
      :rules="rules"
      outlined
      shaped
      readonly
      required
      @click="modalTime = true"
    >
      <v-icon slot="prepend-inner" color="primary" >
        mdi-clock-time-eight-outline
      </v-icon>
    </v-text-field>

    <v-dialog
      ref="dialogTime"
      v-model="modalTime"
      :return-value.sync="model"
      width="unset"
    >
      <v-time-picker format="24hr" v-model="timeModel" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalTime = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="confirmTime()"> OK </v-btn>
      </v-time-picker>
    </v-dialog>
  </div>

</template>
<script>
import moment from "moment";
export default {
  name: "vtime",
  props: ["value", "label", "rules"],
  data() {
    return {
      modalTime: false,
      timeModel: null,
      displayDate: null,

      nameRules: [(v) => !!v || "Field is required"],
    };
  },
  mounted() {
    var d = new Date();
    if (this.value != null) 
      this.timeModel = this.value;
    else  
    {
      d = new Date(this.value);
      this.timeModel = moment(d).format("HH:mm");
    }
      

    
    this.displayDate = this.timeModel;
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(model) {
        console.log(model);
      },
    },
  },

  methods: {
    confirmTime() {
      this.onUpdateDate();
      this.modalTime = false;
    },
    onUpdateDate() {
      if (!this.timeModel) return false;

      this.displayDate = this.timeModel;
      
      this.$emit("input", this.timeModel);
    },    
  },  
};
</script>